/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../service/service";

const useSaveEarlyMarkets = () =>
  useMutation({
    mutationKey: ["saveEarlyMarkets"],
    mutationFn: earlyMarkets => {
      let api__data = {
        reportDate: earlyMarkets.reportDate,
        regionId: earlyMarkets.regionId,
        productLineId: earlyMarkets.productLineId,
        earlyMarketDTO: {
          title: earlyMarkets.title,
          imagePath: earlyMarkets.imagePath,
          imagePath2: earlyMarkets.imagePath2,
          headerImagePath: earlyMarkets.headerImagePath,
          id: earlyMarkets.id
        },
        earlyMarketCommodityDTOS: earlyMarkets.syndicationCommodities.map(comm => ({
          commodity: comm.commodity,
          percentageChange: comm.percentageChange
        })),
      }
      return service.saveEarlyMarkets(api__data)
    },
  });

export default useSaveEarlyMarkets;
